$('.select2').select2()

$(window).on('modal-loaded', function () {
  $('.select2-modaled').each(function () {
    $(this).select2({
      width: '100%',
    })
  })
})
